import dayjs from "dayjs";
import React from "react";
import styled from "styled-components";
import { ScoreItem } from "../../../services/reportsRecapGet";

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  width: 100%;
  padding: 32px;
  background: linear-gradient(to top, #ffffff, #abddffff);
  text-align: center;
`;

const IconWrapper = styled.div`
  font-size: 60px;
  margin-bottom: 24px;
`;

const Title = styled.h2`
  font-size: 28px;
  font-weight: 800;
  color: #0369a1;
  margin-bottom: 32px;
`;

const ScoreCard = styled.div`
  background: white;
  padding: 32px;
  border-radius: 24px;
  box-shadow: 0 10px 30px rgba(0,0,0,0.08);
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  max-width: 280px;
`;

const ScoreLabel = styled.span`
  font-size: 16px;
  color: #64748b;
  margin-bottom: 8px;
`;

const ScoreValue = styled.span`
  font-size: 72px;
  font-weight: 900;
  color: #0ea5e9;
  line-height: 1;
  margin-bottom: 24px;
`;

const DateBox = styled.div`
  padding: 8px 16px;
  border-radius: 8px;
  font-size: 14px;
  color: #475569;
  font-weight: 600;
`;

interface PeakScoreSlideProps {
  history: ScoreItem[];
}

const Description = styled.p`
  color: #475569;
  font-size: 16px;
  line-height: 1.6;
  max-width: 320px;
  margin: 0 auto 32px auto;
`;

const PeakScoreSlide: React.FC<PeakScoreSlideProps> = ({ history }) => {
  const hasData = history && history.length > 0;

  let description = "";
  let maxScoreDisplay = "?";
  let dateText = "¡Descúbrelo!";
  let monthName = "";

  if (hasData) {
    const maxItem = history.reduce((prev, current) =>
      (prev.puntaje > current.puntaje) ? prev : current
      , history[0]);

    monthName = dayjs(maxItem.fecha).locale('es').format("MMMM");
    const peakScore = maxItem.puntaje;
    maxScoreDisplay = peakScore.toString();
    dateText = `Alcanzado en ${monthName}`;

    if (peakScore >= 780) {
      description = `¡Tu mejor momento llegó en ${monthName}! Ese puntaje refleja una gran disciplina. Analiza qué hiciste en este periodo de tiempo para que lo continúes haciendo`;
    } else if (peakScore >= 740) {
      description = `En ${monthName} alcanzaste tu punto más fuerte. Estuviste muy cerca de niveles excelentes.`;
    } else if (peakScore >= 520) {
      description = `Tu momento más fuerte llegó en ${monthName}. Continúa construyendo sobre ese avance, revisa que hiciste diferente para este tiempo y replícalo para el 2026.`;
    } else {
      description = `En ${monthName} alcanzaste un avance importante en tu score. ¡Ese progreso cuenta!`;
    }
  } else {
    description = "Este 2025 estuviste cerca, pero tu mejor momento financiero aún no se ha registrado.";
  }

  return (
    <Container>
      <IconWrapper>🏆</IconWrapper>
      <Title>¡Tu mejor momento!</Title>
      <Description>{description}</Description>

      <ScoreCard>
        <ScoreLabel>Tu puntaje máximo</ScoreLabel>
        <ScoreValue>{maxScoreDisplay}</ScoreValue>
        <DateBox>{dateText}</DateBox>
      </ScoreCard>
    </Container>
  );
};

export default PeakScoreSlide;
